<template>
    <div id="purchase-modal" class="purchase-modal modal" v-bind:class="{ show: showPurchaseModal, 'ui-light-theme' : lightTheme }" tabindex="-1" role="dialog" aria-modal="true" v-if="showPurchaseModal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ modalTitle }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click.prevent="closePurchaseModal()">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body modal-body-padding" v-if="loaded">

                    <!-- <div class="mb-3 pl-5 pr-4">
                        <div class="sale-banner"><h5>Black Friday &amp; Cyber Monday Sale This Week Only!</h5> <div><strong>$10</strong> Solo signatures and <strong>50%</strong> off Yearly Plans!</div></div>
                    </div> -->

                    <form method="POST" v-if="!purchaseSuccessful">
                        
                        <div class="row">
                            <div class="col-md-6">                                        
                                <div class="form-group" v-if="!planWasSet || chosenPlan !== 'solo'">
                                    <label class="sr-only">Company Plan</label>
                                    <select name="period" class="form-control" v-model="chosenPlan">
                                        <option value="solo" v-if="!planWasSet">Individual Plan</option>
                                        <option value="planb10"><template v-if="!planWasSet">Company: </template>Up to 40 Employees</option>
                                        <option value="planb20"><template v-if="!planWasSet">Company: </template>Up to 100 Employees</option>
                                        <option value="planb30"><template v-if="!planWasSet">Company: </template>Up to 250 Employees</option>
                                    </select>
                                    <span class="invalid-feedback show-invalid" role="alert" v-if="this.purchaseErrors && this.purchaseErrors.hasOwnProperty('plan')">
                                        <strong v-text="this.purchaseErrors.plan[0]"></strong>
                                    </span>
                                </div>
                                <div class="form-group" v-if="chosenPlan !== 'solo'">
                                    <label class="sr-only">Period</label>
                                    <select name="period" class="form-control" v-model="monthly">
                                        <option v-bind:value="true">Pay Monthly</option>
                                        <option v-bind:value="false">Pay Yearly ({{ chosenPlanSavings }})</option>
                                    </select>
                                    <span class="invalid-feedback show-invalid" role="alert" v-if="this.purchaseErrors && this.purchaseErrors.hasOwnProperty('period')">
                                        <strong v-text="this.purchaseErrors.period[0]"></strong>
                                    </span>
                                </div>
                                
                                <div class="form-group" v-if="!user_id">
                                    <label class="sr-only">Email Address</label>
                                    <input type="email" name="email" class="form-control" placeholder="Email Address" v-model="accountEmail">
                                    <span class="invalid-feedback show-invalid" role="alert" v-if="this.purchaseErrors && this.purchaseErrors.hasOwnProperty('email')">
                                        <strong v-text="this.purchaseErrors.email[0]"></strong>
                                    </span>
                                </div>
                                <div class="form-group" v-if="!user_id">
                                    <label class="sr-only">Password</label>
                                    <input type="password" name="password" class="form-control" placeholder="Password" v-model="accountPassword">
                                    <span class="invalid-feedback show-invalid" role="alert" v-if="this.purchaseErrors && this.purchaseErrors.hasOwnProperty('password')">
                                        <strong v-text="this.purchaseErrors.password[0]"></strong>
                                    </span>
                                </div>
                                <div class="form-group" v-if="!user_id">
                                    <label class="sr-only">Confirm Password</label>
                                    <input type="password" name="password_confirmation" class="form-control" placeholder="Confirm Password" v-model="accountPasswordConfirm">
                                    <span class="invalid-feedback show-invalid" role="alert" v-if="this.purchaseErrors && this.purchaseErrors.hasOwnProperty('password_confirmation')">
                                        <strong v-text="this.purchaseErrors.password_confirmation[0]"></strong>
                                    </span>
                                </div>
                                <div class="form-group">
                                    <label class="sr-only">Your Name</label>
                                    <input type="text" name="name" class="form-control" placeholder="Your Name" v-model="purchaseName">
                                    <span class="invalid-feedback show-invalid" role="alert" v-if="this.purchaseErrors && this.purchaseErrors.hasOwnProperty('name')">
                                        <strong v-text="this.purchaseErrors.name[0]"></strong>
                                    </span>
                                </div>
                                <div class="form-group">
                                    <label class="sr-only">Company Name</label>
                                    <input type="text" name="organization_name" class="form-control" placeholder="Company Name" v-model="purchaseOrganizationName">
                                    <span class="invalid-feedback show-invalid" role="alert" v-if="this.purchaseErrors && this.purchaseErrors.hasOwnProperty('organization_name')">
                                        <strong v-text="this.purchaseErrors.organization_name[0]"></strong>
                                    </span>
                                </div>
                                <div class="form-group">
                                    <label for="card-element" class="sr-only">Credit or Debit Card</label>
                                    <div class="form-control credit-card">
                                        <div ref="card"></div>
                                    </div>
                                    <span class="invalid-feedback" role="alert" v-if="error">
                                        <strong v-text="error"></strong>
                                    </span>
                                </div>
                                <div class="form-group" v-if="discount.show">
                                    <label class="sr-only">Discount code</label>
                                    <div class="input-group">
                                        <input type="text" name="discount_code" class="form-control" style="width:1%;" placeholder="Discount code" v-model="discount.code">
                                        <div class="input-group-append">
                                            <button class="btn btn-sm btn-mediumblue" v-on:click.prevent="checkDiscountCode()">Apply</button>
                                        </div>
                                    </div>
                                    <span class="valid-feedback show-valid" role="alert" v-if="this.discount.message">
                                        <strong v-text="this.discount.message"></strong>
                                    </span>
                                    <span class="invalid-feedback show-invalid" role="alert" v-if="this.discount.errors">
                                        <strong v-text="this.discount.errors"></strong>
                                    </span>
                                    <span class="invalid-feedback show-invalid" role="alert" v-if="this.purchaseErrors && this.purchaseErrors.hasOwnProperty('discount_code')">
                                        <strong v-text="this.purchaseErrors.discount_code[0]"></strong>
                                    </span>
                                </div>
                            </div><!-- .col-md-6 -->
                            <div class="col-md-6 d-none d-md-block">
                                <h3 class="plan-details-price" v-html="priceText"></h3>
                                <div class="plan-details text-center">
                                    <ul class="pricing-list list-unstyled m-0" v-if="chosenPlan == 'solo'">
                                        <li><strong>One</strong> Signature</li>
                                        <li><strong>Unlimited</strong> Fields &amp; Images</li>
                                        <li>Premium Templates</li>
                                        <li>Premium Fields & Features</li>
                                        <li>Premium Icons</li>
                                        <li>Custom Icon Colors</li>
                                        <li>Signature Saved Forever</li>
                                        <li>Send Signature via Email</li>
                                        <li>Individual Email Support</li>
                                    </ul>
                                    <ul class="pricing-list list-unstyled m-0" v-if="chosenPlan !== 'solo'">
                                        <li><strong>Up to {{ chosenPlanEmployees }}</strong> Employees</li>
                                        <li><strong>{{ chosenPlanBaseSigs }} Templated</strong> Signature Designs</li>
                                        <li><strong>Unlimited</strong> Fields &amp; Images</li>
                                        <li>Premium Templates</li>
                                        <li>Premium Fields & Features</li>
                                        <li>Premium Icons</li>
                                        <li>Custom Icon Colors</li>
                                        <li>Signature Generator Links</li>
                                        <li>Saved Employee Signatures</li>
                                        <li>Send Signatures via Email</li>
                                        <li>Admin Email Support</li>
                                    </ul>
                                </div><!-- .plan-details -->
                            </div><!-- .col-md-6 -->
                        </div><!-- .row -->

                        <div class="text-center mt-3">
                            <button class="btn btn-primary btn-block" v-on:click.prevent="purchase()" v-html="purchaseButtonText" v-bind:disabled="purchaseLoading"></button>
                            <div class="mt-2 text-center" v-if="mode == 'freshaccount' || mode == 'signaturesaved'">
                                <button class="btn btn-link" v-on:click.prevent="closePurchaseModal()" v-if="mode == 'freshaccount' || mode == 'signaturesaved'">Maybe Later, thanks</button>
                            </div>
                        </div><!-- .text-center -->

                    </form>

                    <div class="purchase-successful" v-if="purchaseSuccessful">
                        <div class="alert alert-success">Your purchase was successful. Thanks for your business!</div>
                        <p class="text-center">
                            <a href="/signatures" class="btn btn-primary" v-if="view !== 'designer'">Manage My Signatures</a>
                            <button class="btn btn-primary" v-on:click.prevent="closePurchaseModal()" v-else>Close & Continue</button>
                        </p>
                    </div><!-- .purchase-successful -->
                </div>
                <div class="modal-body modal-body-padding loading" style="min-height:300px;" v-else>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            showPurchaseModal: {
                type: Boolean,
                default: false,
            },
            initialChosenPlan: {
                type: String,
                default: null,
            },
            initialBillingMonthly: {
                type: Boolean,
                default: true,
            },
            singleSignature: {
                type: Boolean,
                default: false,
            },
            view: {
                type: String,
                default: null,
            },
            mode: {
                type: String,
                default: null,
            },
            load_stripe_key: {
                type: String,
                default: false,
            },
            theme: {
                type: String,
                default: 'dark'
            },
        },
        data: function () {
            return {
                loaded: false,
                //modalTitle: 'Signature Saved',
                purchaseLoading: false,
                purchaseSuccessful: false,
                purchaseName: '',
                discount: {
                    show: false,
                    code: '',
                    applied: false,
                    amount: null,
                    percentage: false,
                    message: null,
                    errors: null,
                },
                chosenPlan: 'solo',
                planWasSet: false,
                accountEmail: '',
                accountPassword: '',
                accountPasswordConfirm: '',
                purchaseOrganizationName: '',
                monthly: true,
                purchaseErrors: null,
                user_id: null,
                organization_id: null,
                token: null,
                error: null,
                client_secret: null,
                stripe: undefined,
                stripeResult: null,
                elements: undefined,
                card: undefined,
                showForm: false,
                referral: null,
                style: {
                    base: {
                        color: '#FFFFFF',
                        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        '::placeholder': {
                            color: '#999999'
                        }
                    },
                    invalid: {
                        color: '#fa755a',
                        iconColor: '#fa755a'
                    }
                },
                soloplancost: 19,
                plans: {
                    planb10: {
                        yearly: 199,
                        monthly: 19,
                        templates: 5,
                        employees: 40,
                    },
                    planb20: {
                        yearly: 399,
                        monthly: 39,
                        templates: 10,
                        employees: 100,
                    },
                    planb30: {
                        yearly: 599,
                        monthly: 59,
                        templates: 15,
                        employees: 250,
                    },
                },
                sale: {
                    active: false,
                    solo: 0,
                    plan1monthly: 0,
                    plan1yearly: 0,
                    plan2monthly: 0,
                    plan2yearly: 0,
                }
            }
        },
        mounted() {
            //console.log('Component mounted.')
            if (this.load_stripe_key) {
                this.stripe = Stripe(this.load_stripe_key);
            }
            if (this.theme == 'light') {
                this.style.base.color = '#333333';
            }
            // if (this.initialUserId) {
            //     this.user_id = this.initialUserId;
            // }
            // if (this.initialOrganizationId) {
            //     this.organization_id = this.initialOrganizationId;
            // }
            // if (this.initialEmail) {
            //     this.accountEmail = this.initialEmail;
            // }
            this.monthly = this.initialBillingMonthly;
            if (this.initialChosenPlan) {
                this.chosenPlan = this.initialChosenPlan;
                this.planWasSet = true;
            }
            //  else {
            //     if (this.singleSignature === true) {
            //         this.chosenPlan = 'solo';
            //         this.monthly = false;
            //     } else {
            //         this.chosenPlan = 'company';
            //     }
            // }
            var url = window.location.href;
            if(url.indexOf('?showdiscount') !== -1 && this.chosenPlan !== 'solo') {
                this.discount.show = true;
            } else {
                this.discount.show = false;
            }
            var self = this;
            this.$nextTick(function () {
                window.addEventListener('Rewardful.tracked', function() {
                    self.referral = Rewardful.referral;
                });
                if (typeof Rewardful !== 'undefined') {
                    self.referral = Rewardful.referral;
                }
            });
        },
        watch: {
            showPurchaseModal: function(newValue, oldValue) {
                if (newValue === true && this.loaded === false) {
                    var self = this;
                    axios.post('/generator/start-purchase', {})
                    .then(function (response) {
                        if (response.data.client_secret) {
                            //console.log(response.data);
                            self.user_id = response.data.user_id;
                            self.accountEmail = response.data.user_email;
                            self.organization_id = response.data.organization_id;
                            self.client_secret = response.data.client_secret;
                            self.loaded = true;
                            if (self.chosenPlan) {
                                self.$nextTick(function () {
                                    self.elements = self.stripe.elements();
                                    self.card = self.elements.create('card', {style: self.style});
                                    self.card.mount(self.$refs.card);
                                });
                            }
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
            },
            initialChosenPlan: function(newValue, oldValue) {
                if (this.initialChosenPlan) {
                    this.chosenPlan = newValue;
                    this.planWasSet = true;
                    if (this.singleSignature) {
                    }
                } else {
                    if (this.singleSignature) {
                        this.chosenPlan = 'solo';
                    }
                }
                var url = window.location.href;
                if(url.indexOf('?showdiscount') !== -1 && this.chosenPlan !== 'solo') {
                    this.discount.show = true;
                } else {
                    this.discount.show = false;
                }
            },
            singleSignature: function(newValue, oldValue) {
                if (newValue === true) {
                    this.chosenPlan = 'solo';
                } else {
                    this.chosenPlan = 'company';
                }
            },
            initialBillingMonthly: function(newValue, oldValue) {
                if (this.initialBillingMonthly === true) {
                    this.monthly = true;
                } else {
                    this.monthly = false;
                }
            },
            initialUserId: function(newValue, oldValue) {
                if (this.initialUserId) {
                    this.user_id = newValue;
                }
            },
            initialOrganizationId: function(newValue, oldValue) {
                if (this.initialOrganizationId) {
                    this.organization_id = newValue;
                }
            },
            initialEmail: function(newValue, oldValue) {
                if (this.initialEmail) {
                    this.accountEmail = newValue;
                }
            },
            chosenPlan: function(newValue, oldValue) {
                // if (newValue == 'solo') {
                //     this.monthly = false;
                // }
            },
        },
        computed: {
            pricingPlanSolo: function() {
                if (this.sale.active) {
                    var price = this.soloplancost + this.sale.solo;
                    return "$" + price;
                } else {
                    return "$" + this.soloplancost;
                }
                
            },
            modalTitle: function() {
                if (this.chosenPlan === 'solo' && this.planWasSet) {
                    return "Purchase Individual Plan";
                } else if (this.chosenPlan !== 'solo' && this.planWasSet) {
                    return "Purchase Company Plan";
                } else {
                    return "Purchase Plan";
                }
            },
            chosenPlanBaseSigs: function() {
                if (this.chosenPlan && this.plans.hasOwnProperty(this.chosenPlan)) {
                    return this.plans[this.chosenPlan].templates;
                } else {
                   return '';
                }
            },
            chosenPlanEmployees: function() {
                if (this.chosenPlan && this.plans.hasOwnProperty(this.chosenPlan)) {
                    return this.plans[this.chosenPlan].employees;
                } else {
                   return '';
                }
            },
            chosenPlanSavings: function() {
                if (this.chosenPlan && this.plans.hasOwnProperty(this.chosenPlan)) {
                    if (this.sale.active) {
                        return "Save $" + ((this.plans[this.chosenPlan].monthly * 12) - (this.plans[this.chosenPlan].yearly + this.sale.plan1yearly)) + ' paid yearly!';
                    } else {
                        return "Save $" + ((this.plans[this.chosenPlan].monthly * 12) - this.plans[this.chosenPlan].yearly) + ' paid yearly';
                    }
                } else {
                    return '';
                }
            },
            purchaseButtonText: function() {
                if (this.purchaseLoading) {
                    return "Please wait... <img src='/img/spinner-white.gif' width='30' height='30'>";
                } else {
                    if (this.chosenPlan) {
                        if (this.chosenPlan === 'solo') {
                            return "Purchase for $" + this.soloplancost + " One Time";
                        } else {
                            var price = this.chosenPlanPrice(false);
                            if (this.discount.applied) {
                                if (this.discount.percentage) {
                                    price = Math.round((price - ((this.discount.amount/100) * price)) * 100) / 100;
                                } else {
                                    price = price - this.discount.amount;
                                }
                            }
                            price = price.toLocaleString("en-US", {style:"currency", currency:"USD", minimumFractionDigits: 2, maximumFractionDigits: 2});
                            price = price.replace('.00', '');
                            if (this.monthly) {
                                return "Purchase for " + price + "/month";
                            } else {
                                return "Purchase for " + price + "/year";
                            }
                        }
                    }
                }
            },
            priceText: function() {
                if (this.chosenPlan) {
                    if (this.chosenPlan === 'solo') {
                        if (this.sale.active) {
                            var normalPrice = this.soloplancost - this.sale.solo;
                            return "<strike>$" + normalPrice + "</strike> $" + this.soloplancost + " One Time";
                        } else {
                            return "$" + this.soloplancost + " One Time";
                        }
                    } else {
                        var price = this.chosenPlanPrice(false);
                        if (this.monthly) {
                            return "$" + price + "/month";
                        } else {
                            if (this.sale.active) {
                                // var normalPrice = null;
                                // if (this.chosenPlan == 'plan1') {
                                //     normalPrice = price - this.sale.plan1yearly;
                                // } else if (this.chosenPlan == 'plan2') {
                                //     normalPrice = price - this.sale.plan2yearly;
                                // }
                                //return "<strike>$" + normalPrice + "</strike> $" + price + "/year";
                            } else {
                                return "$" + price + "/year";
                            }
                        }
                    }
                }
            },
            lightTheme: function() {
                if (this.theme == 'light') {
                    return true;
                } else {
                    return false;
                }
            }
        },
        methods: {
            choosePlan: function(planType) {
                var self = this;
                self.chosenPlan = planType;
                //self.canRechoosePlan = true;
                self.$nextTick(function () {
                    self.elements = self.stripe.elements();
                    self.card = self.elements.create('card', {style: self.style});
                    self.card.mount(self.$refs.card);
                });
            },
            chosenPlanPrice: function(withDollarSymbol = true) {
                if (this.chosenPlan && this.plans.hasOwnProperty(this.chosenPlan)) {
                    var price = 0;
                    if (this.monthly) {
                        price = this.plans[this.chosenPlan].monthly;
                    } else {
                        price = this.plans[this.chosenPlan].yearly;
                    }
                    if (withDollarSymbol) {
                        price = "$" + price;
                    }
                    return price;
                } else {
                    return '';
                }
            },
            // loadedShow: function() {
            //     if (!this.showForm) {
            //         return true;
            //     } else if (this.loaded) {
            //         return true;
            //     } else {
            //         return false;
            //     }
            // },
            // pricingPlanSavings: function() {
            //     return "$" + ((this.prices[this.chosenPlan].monthly * 12) - this.prices[this.chosenPlan].yearly);
            // },
            // showTheForm: function() {
            //     this.showForm = true;
            //     this.modalTitle = 'Purchase Plan';
            //     var self = this;
            //     axios.post('/generator/start-purchase', {})
            //     .then(function (response) {
            //         if (response.data.client_secret) {
            //             //console.log(response.data);
            //             self.user_id = response.data.user_id;
            //             self.accountEmail = response.data.user_email;
            //             self.organization_id = response.data.organization_id;
            //             self.client_secret = response.data.client_secret;
            //             self.loaded = true;
            //             self.$nextTick(function () {
            //                 self.elements = self.stripe.elements();
            //                 self.card = self.elements.create('card', {style: self.style});
            //                 self.card.mount(self.$refs.card);
            //             });
            //         }
            //     })
            //     .catch(function (error) {
            //         console.log(error);
            //     });
                
            // },
            closePurchaseModal() {
                if(this.card !== undefined) {
                    this.card.unmount();
                }
                this.$nextTick(function () {
                    this.loaded = false;
                    this.$emit('closepurchasemodal');
                });
            },
            // checkChosenPlan: function() {
            //     if (this.chosenPlan == 'solo') {
            //         this.purchasePeriod = 'yearly';
            //     }
            // },
            purchase: function () {
                var self = this;
                self.purchaseLoading = true;
                if (this.stripeResult) {
                    self.savePurchaseData();
                } else {
                    self.stripe.handleCardSetup(self.client_secret, self.card, {
                        payment_method_data: {
                            billing_details: {
                                email: self.accountEmail
                            }
                        }
                    }).then(function(result) {
                        // Handle result.error or result.setupIntent
                        //console.log(result);
                        if (result.error) {
                            console.log(result.error);
                            self.error = result.error.message;
                            self.purchaseLoading = false;
                        } else {
                            //console.log("success!");
                            self.error = null;
                            self.stripeResult = result;
                            //console.log(result);
                            self.savePurchaseData();
                        }
                    });
                }
            },
            checkDiscountCode() {
                var self = this;
                if (self.discount.show && self.discount.code !== '') {
                    axios.post('/generator/check-discount-code', { 'discount_code': self.discount.code })
                    .then(function (response) {
                        if (response.data.status === 'success') {
                            self.discount.applied = true;
                            self.discount.amount = response.data.discount.amount;
                            self.discount.percentage = response.data.discount.percentage;
                            self.discount.errors = null;
                            self.discount.message = response.data.message;
                        } else if (response.data.status === 'error') {
                            self.discount.applied = false;
                            self.discount.amount = null;
                            self.discount.percentage = false;
                            self.discount.message = null;
                            self.discount.errors = response.data.message;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
            },
            savePurchaseData: function() {
                var self = this;
                self.purchaseErrors = null;
                var object_to_send = null;
                var planName = '';
                var planPrice = '';
                if (self.chosenPlan === 'solo') {
                    planName = 'solo';
                    planPrice = this.soloplancost;
                } else {
                    planName = this.chosenPlan;
                    if (this.monthly === false) {
                        planPrice = self.plans[this.chosenPlan].yearly;
                    } else {
                        planPrice = self.plans[this.chosenPlan].monthly;
                    }
                }
                if (self.user_id && self.organization_id) {
                    object_to_send = {payment_method: self.stripeResult.setupIntent.payment_method, user_id: self.user_id, organization_id: self.organization_id, organization: self.purchaseOrganizationName, name: self.purchaseName, plan: planName, monthly: self.monthly, referral: self.referral};
                } else {
                    object_to_send = {email: self.accountEmail, password: self.accountPassword, password_confirmation: self.accountPasswordConfirm, payment_method: self.stripeResult.setupIntent.payment_method, organization: self.purchaseOrganizationName, name: self.purchaseName, plan: planName, monthly: self.monthly, referral: self.referral};
                }
                if (self.discount.code !== '' && self.discount.applied) {
                    object_to_send.discount_code = self.discount.code;
                }
                axios.post('/generator/purchase', object_to_send)
                .then(function (response) {
                    //console.log(response);
                    self.user_id = response.data.user.id;
                    self.organization_id = response.data.organization.id;
                    self.purchaseSuccessful = true;
                    self.purchased = true;
                    self.purchaseLoading = false;
                    if (typeof gtag != "undefined") {
                        //console.log("GTAg was defined");
                        // gtag('event', 'conversion', {
                        //     'send_to': 'AW-1035274589/_q36CInl1qwBEN2S1O0D',
                        //     'value': price,
                        //     'currency': 'USD',
                        // });
                        gtag('event', 'purchase', {
                            //"send_to": "UA-143733930-1",
                            "value": planPrice,
                            "currency": "USD",
                            "transaction_id": response.data.transaction_id,
                            "items": [
                                {
                                    "item_id": planName.toUpperCase(),
                                    "item_name": planName,
                                    "quantity": 1,
                                    "price": planPrice
                                }
                            ]
                        });
                    }
                    self.$emit('purchasesuccessful', response.data.user, response.data.organization);
                    return true;
                })
                .catch(function (error) {
                    self.purchaseLoading = false;
                    if (error.response.data.errors) {
                        self.purchaseErrors = error.response.data.errors;
                    } else {
                        console.log(error);
                        console.log(error.response);
                    }
                });
            }
        }
    }
</script>
